var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var RecordHistory = /** @class */ (function (_super) {
    __extends(RecordHistory, _super);
    function RecordHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            recordTime: [],
            callDuration: {
                max: "",
                min: ""
            },
            personalName: "",
            targetName: "",
            targetPhone: ""
        };
        _this.dataSet = [];
        return _this;
    }
    /**
     * 范围组件数据重置
     */
    RecordHistory.prototype.handleResetForm = function () {
        this.searchModel.callDuration = { min: "", max: "" };
    };
    //获取录音历史
    RecordHistory.prototype.refreshData = function () {
        var _this = this;
        this.searchModel.caseId = this.caseId;
        this.caseOperatorPageService
            .caseTelRecord(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    RecordHistory.prototype.activated = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], RecordHistory.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RecordHistory.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], RecordHistory.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], RecordHistory.prototype, "caseId", void 0);
    RecordHistory = __decorate([
        Component({
            components: {
                NumberRange: NumberRange
            }
        })
    ], RecordHistory);
    return RecordHistory;
}(Vue));
export default RecordHistory;
